const KNOWN_REASONS = new Set(['partstech_first_order', 'admin_grant']);

export const getGrantCopyKeys = (reason: string): { headline: string; body: string } => {
  const key = KNOWN_REASONS.has(reason) ? reason : 'default';
  return {
    headline: `subscription.promotionalGrant.reasons.${key}.headline`,
    body: `subscription.promotionalGrant.reasons.${key}.body`,
  };
};
